export default __webpack_public_path__ + "static/media/fw-grace-er-White Gold.6f0cd1a5.mp4";